var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrendArrows = function SvgTrendArrows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.95 7.95-1.414 1.414L8 6.828V20H6V6.828L3.465 9.364 2.05 7.95 7 3l4.95 4.95Zm10 8.1L17 21l-4.95-4.95 1.414-1.414L16 17.172 16 4h2v13.172l2.536-2.536 1.414 1.414Z",
    fill: "#000"
  })));
};
export default SvgTrendArrows;